// This file contains two closely related exports that work together with use-clicked-on-vector-map.ts:
//
// - RanaMapDisplayVectors renders vector layers onto the map. Each layer is either rendered via
//   its style layers (styleLayer.id) or falls back to the descriptor layer id.
//
// - getVectorLayers produces the vectorLayers config for useClickedOnVectorMap, mapping the same
//   layer ids that RanaMapDisplayVectors renders to titles. This is important because
//   useClickedOnVectorMap filters queryRenderedFeatures by layerId — so the ids produced by
//   getVectorLayers must exactly match the layer ids that RanaMapDisplayVectors registers on the map.

import { VectorDescriptorLayer } from "@/utils/get-vector-descriptor-layers-and-sprite";

import { RanaMap } from "..";

export const getVectorLayers = (layers: VectorDescriptorLayer[]) => {
  return layers.flatMap(({ layer, styleLayers, descriptorId }) =>
    styleLayers
      ? styleLayers.map((styleLayer) => ({
          title: layer,
          layerId: styleLayer.id,
          descriptorId,
          layerName: layer,
        }))
      : [{ title: layer, layerId: layer, descriptorId, layerName: layer }]
  );
};

interface DisplayLayer extends VectorDescriptorLayer {
  isVisible: boolean;
  beforeId?: string;
}

export const RanaMapDisplayVectors = ({ layers }: { layers: DisplayLayer[] }) => {
  return layers.map((layer) => {
    return <RanaMap.VectorLayer key={layer.layer + layer.descriptorId + layer.url} {...layer} />;
  });
};
